export const VARIATION_TYPE = {
    SUGGESTED: 'suggested',
    DRAFT: 'draft',
    ORDERED: 'ordered',
};
